"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _forEach = _interopRequireDefault(require("lodash/forEach"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _moment = _interopRequireDefault(require("moment"));
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
var timeUnits = ['years', 'months', 'days'];
function formatAge(dob) {
  if ((0, _isNil.default)(dob) || dob === '') {
    return '- -';
  }
  var age = null;
  var unit = null;
  (0, _forEach.default)(timeUnits, function (timeUnit) {
    age = (0, _moment.default)().diff(dob, timeUnit);
    if (age > 0) {
      unit = timeUnit;
    } else if (timeUnit === 'days') {
      unit = timeUnit;
      age = 1;
    }
    return (0, _isNil.default)(unit);
  });
  if (age === 1) {
    unit = unit.substr(0, unit.length - 1);
  }
  return "".concat(age, " ").concat(unit);
}
var _default = formatAge;
var _default2 = _default;
exports.default = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(timeUnits, "timeUnits", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/stores/common/format-age.js");
  reactHotLoader.register(formatAge, "formatAge", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/stores/common/format-age.js");
  reactHotLoader.register(_default, "default", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/stores/common/format-age.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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